// extracted by mini-css-extract-plugin
export default {"sectionCotainer":"style_sectionCotainer__5uyQ0","textBox":"style_textBox__qM5Z4","mission":"style_mission__PhvsD"};